import { initProject, getProjectIdByUserId, insertProject, getProjectById, updateProject, getProjectListAudit, getProjectUserAndRole, getProjectUserAndRoleCount, getProjectRoleCv, modifyProjectUserRole, getOpenSourceProject, toAddProjectUserAndRole, getOpenSourceProjectCount, modifyProjectNameInMeta } from 'api/project'

const project1 = {
  state: {
    labList: [],
    organizationList: [],
    projectList: [],
    privateList: [],
    projectDetail: {},
    projectListNum: 0,
    projectIdList: []
  },
  mutations: {
    SET_CVDATA (state, data) {
      // state.labList = data.lab.map((item) => {
      //   return {label: item.labNameEn, value: item.id}
      // })
      state.organizationList = data.organization.map((item) => {
        return {label: item.orgNameEn, value: item.id}
      })
    },
    SET_PROJECTLIST (state, data) {
      state.projectList = data
    },
    SET_PRIVATELIST (state, data) {
      state.privateList = data.listProject
      state.projectListNum = data.totalCount[0]
    },
    SET_PROJECTDETAIL (state, data) {
      state.projectDetail = data
    },
    SET_PROJECTIDLIST: (state, list) => {
      state.projectIdList = list
    },
    SET_RESIZEHEIGHT: (state, data) => {
      state.resizeHeight = data
    }
  },
  actions: {
    // ums
    getProjectListAudit ({commit}, param) {
      return new Promise((resolve, reject) => {
        getProjectListAudit(param).then((res) => {
          commit('SET_PROJECTLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    toAddProjectUserAndRole ({commit}, param) {
      return new Promise((resolve, reject) => {
        toAddProjectUserAndRole(param).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    modifyProjectUserRole ({commit}, param) {
      return new Promise((resolve, reject) => {
        modifyProjectUserRole(param).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getProjectRoleCv ({commit}, param) {
      return new Promise((resolve, reject) => {
        getProjectRoleCv(param).then((res) => {
          console.log(res)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getProjectUserAndRole ({commit}, param) {
      return new Promise((resolve, reject) => {
        getProjectUserAndRole(param).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getProjectUserAndRoleCount ({commit}, param) {
      return new Promise((resolve, reject) => {
        getProjectUserAndRoleCount(param).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // management
    getResizeHeight ({commit}, data) {
      data.height = window.innerHeight - data.num + 'px'
      window.onresize = () => {
        data.height = window.innerHeight - data.num + 'px'
      }
    },
    getInitProject ({commit}, param) {
      return new Promise((resolve, reject) => {
        initProject(param).then((res) => {
          commit('SET_CVDATA', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    insertProject ({commit}, params) {
      return new Promise((resolve, reject) => {
        insertProject(params).then((res) => {
          console.log(res)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getOpenSourceProject ({commit}, params) {
      return new Promise((resolve, reject) => {
        getOpenSourceProject(params).then((res) => {
          commit('SET_PROJECTLIST', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getProjectById ({commit}, params) {
      return new Promise((resolve, reject) => {
        getProjectById(params).then((res) => {
          // console.log(res)
          commit('SET_PROJECTDETAIL', res.result)
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getProjectNameById ({commit}, data) {
      return new Promise((resolve, reject) => {
        getProjectById(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    updateProject ({commit}, params) {
      return new Promise((resolve, reject) => {
        updateProject(params).then((res) => {
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getOpenSourceProjectCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getOpenSourceProjectCount(params).then((res) => {
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getProjectIdList ({commit}) {
      return new Promise((resolve, reject) => {
        getProjectIdByUserId().then((res) => {
          commit('SET_PROJECTIDLIST')
          resolve(res.result.projectIdList)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    modifyProjectNameInMeta ({commit}, params) {
      return new Promise((resolve, reject) => {
        modifyProjectNameInMeta(params).then((res) => {
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
export default project1



// WEBPACK FOOTER //
// ./src/store/modules/project1.js